import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Component, hydrate } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {

        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }

        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);

    };
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

//on Page type pages, the root element is predefined, delete it as we are populating with JS
var rootElement = document.getElementById('root');
var prerendered = document.getElementById('prerendered');
if (prerendered) {
    prerendered.parentNode.removeChild(prerendered);
}
class NewVersionAlert extends Component {
    static displayName = App.name;
    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
    }
    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={this.state.open}
                onClose={() => this.setState({ open: false })}
                message="A new version of the app is available, please refresh your browser."
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => this.setState({ open: false })}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        );
    }
}
const onUpdate = () => {
    // show alert
    const d = document.createElement("div")
    d.id = "newversion-alert";
    rootElement.appendChild(d);
    ReactDOM.render(<NewVersionAlert />, document.getElementById("newversion-alert"));
}

var jsss = document.querySelectorAll("style[data-jss]:not([data-meta='makeStyles'])");
for (var i = 0; i < jsss.length; i++)
    jsss[i].parentNode.removeChild(jsss[i]);

if (rootElement.hasChildNodes()) {
    console.log("hydrating...");
    //ReactDOM.hydrate(<BrowserRouter basename={baseUrl}><App prerendering={false} /></BrowserRouter>, rootElement);
    ReactDOM.render(<BrowserRouter basename={baseUrl}><App prerendering={false} /></BrowserRouter>, rootElement);
    //registerServiceWorker(onUpdate);
    unregister();
} else {
    console.log("rendering...");
    ReactDOM.render(<BrowserRouter basename={baseUrl}><App prerendering={true} /></BrowserRouter>, rootElement);
}